/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/open_happiness': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 10l-7 4 2 4h10l2-4-7-4zm0 6a1 1 0 110-2 1 1 0 010 2zM16 22c3.789 0 5-3 5-3H11s1.211 3 5 3z"/><path pid="1" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/>'
  }
})
